import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { Mark } from "@tiptap/pm/model";
import { BubbleMenu, Editor } from "@tiptap/react";
import PenOutlineIcon from "@src/lib/icons/18px/pen-outline";
import TrashOutlineIcon from "@src/lib/icons/18px/trash-outline";
import { FC, useEffect, useState } from "react";
import { cn } from "@src/lib/utils/cn";
import EditLinkDialog from "./EditLinkDialog";
type Props = {
  editor: Editor;
};

export const LinkEditor: FC<Props> = ({ editor }) => {
  const [mark, setMark] = useState<Mark>();
  const [editLinkOpen, setEditLinkOpen] = useState(false);
  useEffect(() => {
    const { $from } = editor.state.selection;
    const mark = $from.marks().find((mark: Mark) => mark.type.name === "link");
    if (!mark) {
      setMark(undefined);
      return;
    }
    setMark(mark);
  }, [editor.state.selection]);

  return (
    <BubbleMenu
      tippyOptions={{
        duration: 100,
        interactive: true,
        placement: "top",
      }}
      editor={editor}
      className="relative flex rounded-2xl bg-white p-2.5 shadow-[0px_8px_64px_0px_rgba(0,0,0,0.06),0px_0px_4px_0px_rgba(0,0,0,0.04)]"
      shouldShow={({ editor }) => {
        return (
          editor.isEditable &&
          !!editor.state.selection.$from
            .marks()
            .find((mark: Mark) => mark.type.name === "link")
        );
      }}
    >
      <div className="flex items-center p-1">
        <Text
          linkOpenInNewTab
          type="P2"
          fontWeight="SemiBold"
          link={mark?.attrs.href}
          className={cn("mr-2 w-[120px] flex-1", "text-gray-10")}
          ellipsis
        >
          {mark?.attrs.href.replace(/(^\w+:|^)\/\//, "")}
        </Text>

        <Button
          variant="secondary"
          size="icon"
          className="mr-1"
          onClick={() => setEditLinkOpen(true)}
        >
          <PenOutlineIcon className="size-4" />
        </Button>

        <Button
          variant="secondary"
          size="icon"
          onClick={() => {
            editor
              .chain()
              .focus()
              .extendMarkRange("link")
              .toggleMark("link")
              .run();
          }}
        >
          <TrashOutlineIcon className="size-4" />
        </Button>
      </div>
      {editLinkOpen && (
        <EditLinkDialog
          open={editLinkOpen}
          onOpenChange={setEditLinkOpen}
          hideTextField
          initialLink={mark?.attrs.href}
          onComplete={(_text, link) => {
            if (!mark) {
              return;
            }
            editor
              .chain()
              .focus()
              .extendMarkRange("link")
              .setLink({ href: link })
              .run();
          }}
        />
      )}
    </BubbleMenu>
  );
};
